import {
	BagTransportTerm,
	BagTransportTermApiResponse,
	BagTransportTermProduct,
	GeneratedReport,
	GenerateReportPayload,
	Report,
	TourismEventsWithDelay,
	TransportTermList,
	VehicleModel,
} from '@/bag/bag-transport-term/bag-transport-term.model';
import { DataBagService } from '@/common/data-bag.service';
import { Data2Service } from '@/common/data2.service';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TransportTerm } from '@/new-transport/_models/transport.model';
import { Result } from '@/reservation/reservation.model';
import { TransportTermCheckList, TransportTermCheckListPayload } from '@/codebook/check-list/check-list.model';

@Injectable({
	providedIn: 'root',
})
export class BagTransportTermApiService {
	constructor(
		private readonly bag: DataBagService,
		private readonly erpApi: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly httpClient: HttpClient,
	) {}

	getTourismEvents(departureDate: string, returnDate: string): Promise<TourismEventsWithDelay[]> {
		return new Promise((resolve, reject) => {
			this.erpApi.get(
				`/tourismEvents/?showDeleted=0&on=1&date_from=${departureDate}&date_to=${returnDate}`,
				(result: BagTransportTermApiResponse, error) => {
					if (error) {
						reject();
					} else {
						resolve(result.data);
					}
				},
			);
		});
	}

	getTransportTerm(params: string): Observable<Result<TransportTermList>> {
		return this.httpClient.get<Result<TransportTermList>>(
			`${environment.apiUrl}/transport/transport_term/?${params}`,
		);
	}

	getTransportTermCheckList(id: number): Observable<Result<TransportTermCheckList>> {
		return this.httpClient.get<Result<TransportTermCheckList>>(
			`${environment.apiUrl}/transport/transport_term/${id}/checklist/?limit=999`,
		);
	}

	importTransportTermCheckList(id: number): Observable<Result<TransportTermCheckList>> {
		return this.httpClient.post<Result<TransportTermCheckList>>(
			`${environment.apiUrl}/transport/transport_term/${id}/checklist/import/?limit=999`,
			{},
		);
	}

	patchTransportTermCheckList(
		id: number,
		checkListId: number,
		payload: Partial<TransportTermCheckList>,
	): Observable<Result<TransportTermCheckList>> {
		return this.httpClient.patch<Result<TransportTermCheckList>>(
			`${environment.apiUrl}/transport/transport_term/${id}/checklist/${checkListId}/`,
			payload,
		);
	}

	createTransportTermCheckList(
		id: number,
		payload: TransportTermCheckListPayload,
	): Observable<TransportTermCheckList> {
		return this.httpClient.post<TransportTermCheckList>(
			`${environment.apiUrl}/transport/transport_term/${id}/checklist/`,
			payload,
		);
	}

	deleteTransportTermCheckList(termId: number, checkListId: number): Observable<TransportTermCheckList> {
		return this.httpClient.delete<TransportTermCheckList>(
			`${environment.apiUrl}/transport/transport_term/${termId}/checklist/${checkListId}/`,
		);
	}

	patchTransportTermData(transportTermId: number, transportData: Partial<BagTransportTerm>): Promise<void> {
		return new Promise((resolve, reject) => {
			this.bag.patch(`/transport/transport_term/${transportTermId}/`, transportData, (result: any, error) => {
				if (error) {
					reject();
				} else {
					this.infobox.success('Zapisano');
					resolve();
				}
			});
		});
	}

	getVehiclesData(): Promise<VehicleModel[]> {
		return new Promise((resolve, reject) => {
			this.erpApi.get(`/vehicles`, (result: any, error) => {
				if (error) {
					reject();
				} else {
					resolve(result.data);
				}
			});
		});
	}

	getVehicleData(vehicle: string): Promise<VehicleModel> {
		return new Promise((resolve, reject) => {
			this.erpApi.get(`/vehicles/${vehicle}`, (result: any, error) => {
				if (error) {
					reject();
				} else {
					resolve(result);
				}
			});
		});
	}

	generateReportFile(reportPayload: GenerateReportPayload): Promise<Report> {
		return new Promise((resolve, reject) => {
			this.bag.post(`/report/`, reportPayload, (result: Report, error: any) => {
				if (error) {
					reject();
				} else {
					resolve(result);
				}
			});
		});
	}

	downloadReportFile(reportPayload: GenerateReportPayload, reportUrl: string): Observable<Blob> {
		return this.httpClient.post(`${environment.apiUrl}/report/${reportUrl}/`, reportPayload, {
			responseType: 'blob',
		});
	}

	downloadReportFileUrl(reportPayload: GenerateReportPayload, reportUrl: string): Observable<string> {
		return this.httpClient.post<string>(`${environment.apiUrl}/report/${reportUrl}/`, reportPayload);
	}

	getReport(reportUrl: string): Promise<GeneratedReport> {
		return new Promise((resolve, reject) => {
			this.bag.get(reportUrl, (result: GeneratedReport, error) => {
				if (error) {
					reject();
				} else {
					resolve(result);
				}
			});
		});
	}

	getProduct(id: number): Promise<BagTransportTermProduct> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/product/${id}/`, (result: BagTransportTermProduct, error) => {
				if (error) {
					reject();
				} else {
					resolve(result);
				}
			});
		});
	}

	patchTransportTerm(id: number, patchData: Partial<TransportTerm>): Observable<TransportTerm> {
		return this.httpClient.patch<TransportTerm>(`${environment.apiUrl}/transport/transport_term/${id}/`, patchData);
	}
}
